// extracted by mini-css-extract-plugin
export default {"icon":"select-similarity_icon__dHltC"};